import { useEffect } from 'react';
import enviro from 'enviro';
import Raven from 'raven-js';
import { useDataSyncApps } from './useDataSyncApps';
import { getReconnectionConfig } from '../utils/getReconnectionConfig';
import { useDashworksAppIds } from './useDashworksAppIds';
export const useServiceComponent = ({
  metadata,
  url
}) => {
  const appId = (metadata === null || metadata === void 0 ? void 0 : metadata.appId) || 0;
  const {
    data: dataSyncApps,
    isLoading: dataSyncAppsLoading,
    error: dataSyncAppsError
  } = useDataSyncApps();
  const {
    data: dashworksAppIds,
    isLoading: isDashworksAppIdsLoading,
    error: dashworksAppIdsError
  } = useDashworksAppIds();
  useEffect(() => {
    if (!appId) {
      const err = new Error('ReconnectButton requires appId');
      if (enviro.isQa()) {
        console.error(err);
      }
      Raven.captureException(err);
      throw err;
    }
  }, [appId]);
  const isDataSyncApp = dataSyncApps.some(({
    appId: dataSyncAppId
  }) => dataSyncAppId === appId);
  const isDashworksApp = dashworksAppIds.some(dashworkAppId => dashworkAppId === appId);
  const reconnectionConfig = getReconnectionConfig({
    appId,
    isDataSyncApp,
    isDashworksApp,
    hasUrl: !!url
  });
  const ServiceComponent = reconnectionConfig === null || reconnectionConfig === void 0 ? void 0 : reconnectionConfig.serviceComponent;
  return {
    serviceComponent: ServiceComponent || null,
    loading: dataSyncAppsLoading || isDashworksAppIdsLoading,
    error: dataSyncAppsError || dashworksAppIdsError
  };
};